import { useState } from "react";

export const ReadMore = ({ children, limit = 90 }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);

  // If text is shorter than limit, just show it without the toggle
  if (text.length <= limit) {
    return <p className="menu-desc">{text}</p>;
  }

  const toggleReadMore = (e) => {
    e.preventDefault(); // Prevent link clicks if wrapped in <a>
    setIsReadMore(!isReadMore);
  };

  return (
    <p className="menu-desc">
      {isReadMore ? text.slice(0, limit) : text}
      <span
        onClick={toggleReadMore}
        className="read-more-inline"
        style={{ color: "var(  --pc-sidebar-active-color)", cursor: "pointer", fontWeight: "500" }}
      >
        {isReadMore ? "... read more" : " show less"}
      </span>
    </p>
  );
};